
/**
@description Register custom handlers here  
@example 

ComponentManager.addHandler("foo", (data) => {
    console.log("foo", data);
});

*/


touchKit.ComponentManager.addHandler("externalLink", (data) => {
    var url = data.externalUrl.includes("http") ? data.externalUrl : "http://" + data.externalUrl;

    touchKit.TrackingManager.track(touchKit.TrackingManager.events.CONTENT_CLICKED, {
        type: "externalLink",
        data: {
            url: url
        }

    });

    window.open(url, data.target);
});



touchKit.ComponentManager.addHandler("internalLink", (data) => {
    app.vm.$router.push(data.route.replace(/\{root\}/, app.defaultRoute));
})


touchKit.ComponentManager.addHandler("eventDispatcher", (data) => {
    app.radio.$emit(data.event, data.payload)
});